import { useSelector } from "react-redux";
import { getRouterState } from "../../redux/rootReducer";
import * as React from "react";
import { useEffect } from "react";
import io from "../../redux/io";
import { style } from "typestyle";
import { getGcpRegistryAppLink } from "../../utils/getGcpRegistryAppLink";

export const RedirectToGcpRegistryApp = () => {
  const routerState = useSelector(getRouterState);
  const { customerId, siteId } = routerState.data;

  useEffect(() => {
    io.changeLocation(getGcpRegistryAppLink(customerId, siteId));
  }, []);

  return (
    <div className={style({ padding: 10 })}>
      You are being redirected to the GCP Registry App...
    </div>
  );
};
